export default "__VITE_ASSET__DaMDFJEV__"